import { DS_LOGOS } from '@/constant/dsLogos'

const MIME_TYPE_LOGOS = {
  'application/vnd.google-apps.presentation': DS_LOGOS.googleSlides,
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': DS_LOGOS.powerpoint,
  'application/vnd.ms-powerpoint': DS_LOGOS.powerpoint,
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': DS_LOGOS.excel,
  'application/vnd.ms-excel': DS_LOGOS.excel,
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': DS_LOGOS.word,
  'application/msword': DS_LOGOS.word,
  'application/pdf': DS_LOGOS.pdf,
}

const EXTENSION_LOGOS = {
  ppt: DS_LOGOS.powerpoint,
  pptx: DS_LOGOS.powerpoint,
  xls: DS_LOGOS.excel,
  xlsx: DS_LOGOS.excel,
  doc: DS_LOGOS.word,
  docx: DS_LOGOS.word,
  pdf: DS_LOGOS.pdf,
}

const MIME_TYPE_ICONS = {
  'image/jpeg': 'image',
  'image/png': 'image',
}

const EXTENSION_ICONS = {
  jpg: 'image',
  jpeg: 'image',
  png: 'image',
}

export const DEFAULT_FILE_ICON = 'document'

function extensionOf(filename) {
  return filename && filename.includes('.')
    ? filename.split('.').pop().toLowerCase()
    : ''
}

export function getFileTypeLogo({ mimeType, filename } = {}) {
  if (mimeType && MIME_TYPE_LOGOS[mimeType]) return MIME_TYPE_LOGOS[mimeType]
  return EXTENSION_LOGOS[extensionOf(filename)] || null
}

export function getFileTypeIconName({ mimeType, filename } = {}) {
  if (mimeType && MIME_TYPE_ICONS[mimeType]) return MIME_TYPE_ICONS[mimeType]
  return EXTENSION_ICONS[extensionOf(filename)] || DEFAULT_FILE_ICON
}
